import { Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { TUser } from "@/types"
import { anniversaryDiff, dayjs } from "@/utils"
import { Panel } from "./utils"

const delta = 7

export function ProfileBirthday({ user }: { user: TUser }) {
  const { t } = useTranslation()

  const days = anniversaryDiff(user.birthday)
  if (days === undefined || days > delta) return null

  return (
    <Panel>
      <Stack p="md" align="center" justify="center" gap="sm" data-testid="birthday">
        <Text fz={24} c="dimmed">
          {t("Birthday")}
        </Text>
        <Text fz={100} lh="100px">
          {days == 0 ? "🎂" : days < 3 ? "🎁" : days < 5 ? "🎈" : "🎊"}
        </Text>
        <Text fz={24} c="red" fw={500}>
          {days == 0
            ? t("Happy Birthday!")
            : days == 1
              ? t("Tomorrow")
              : dayjs().startOf("day").add(days, "day").fromNow()}
        </Text>
      </Stack>
    </Panel>
  )
}
